/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_baseLodash.js
 ** module id = 225
 ** module chunks = 0
 **/